import { useCallback } from 'react';
import { apiLottoAssistantConversation } from '@homeplay/api';
import {
  createUserMessage,
  createAssistantMessage,
  createErrorMessage,
} from '../utils/messageFactory';
import { getLottoErrorMessage } from '../utils/error';

export const useLottoAssistantMessaging = ({
  unitToken,
  conversationId,
  activity,
  onAppendMessage,
  onConversationIdChange,
  onSetIsSendingMessage,
  metadataManager,
  submissionLock,
}) => {
  const sendMessageToApi = useCallback(
    async ({ apiText, metadata, shouldClearMetadata }) => {
      if (!unitToken) return;

      await submissionLock.withLock(async () => {
        const userMessage = createUserMessage(apiText);
        onAppendMessage(userMessage);
        onSetIsSendingMessage?.(true);

        try {
          const response = await apiLottoAssistantConversation({
            unitToken,
            prompt: apiText,
            conversationId,
            metadata,
            activity,
          });

          if (shouldClearMetadata) {
            metadataManager.clearMetadata();
          }

          const assistantMessage = createAssistantMessage(
            response?.response ?? '',
            response?.a2ui ?? null
          );
          onAppendMessage(assistantMessage);

          if (response?.conversation_id) {
            onConversationIdChange(response.conversation_id);
          }
        } catch (error) {
          const errorMessage = createErrorMessage(getLottoErrorMessage(error));
          onAppendMessage(errorMessage);
        } finally {
          onSetIsSendingMessage?.(false);
        }
      });
    },
    [
      unitToken,
      conversationId,
      activity,
      onAppendMessage,
      onConversationIdChange,
      onSetIsSendingMessage,
      metadataManager,
      submissionLock,
    ]
  );

  return { sendMessageToApi };
};
